import { v4 as uuidv4 } from "uuid";

// This function generates a random UUID (Universally Unique Identifier).

export const generateUUID = () => uuidv4();
